<div class="pdf-page app-aul-006a-24" id="aul006a24">
  <!-- <app-policy-header></app-policy-header>-->
  <p class="font-large" style="text-align: center">
    <b>
      U.S. TERRORISM RISK INSURANCE ACT OF 2002 AS AMENDED <br />

      NEW & RENEWAL BUSINESS ENDORSEMENT</b
    >
  </p>

  <p class="font-small">
    <b>
      This Endorsement is issued in accordance with the terms and conditions of
      the "U.S. Terrorism Risk Insurance Act of 2002" as amended, as summarized
      in the POLICYHOLDER DISCLOSURE NOTICE OF TERRORISM INSURANCE COVERAGE
      attached to this Policy
    </b>
  </p>
  <br />
  <p class="font-small">
    In consideration of the additional premium described in the TRIA section of
    the Commercial Lines Policy Common Policy Declarations, it is hereby noted
    and agreed with effect from inception that the Terrorism exclusion to which
    this Insurance (Policy) is subject, shall not apply to any “insured loss”
    directly resulting from any "act of terrorism" as defined in the "U.S.
    Terrorism Risk Insurance Act of 2002", as amended ("TRIA").
  </p>
  <p class="font-small">
    The coverage afforded by this Endorsement is only in respect of any “insured
    loss” of the type insured by this Insurance (Policy) directly resulting from
    an "act of terrorism" as defined in TRIA. The coverage provided by this
    Endorsement shall expire at 12:00 midnight December 31, 2027, the date on
    which the TRIA Program is scheduled to terminate, or the expiry date of the
    policy whichever occurs first and shall not cover any losses or events which
    arise after the earlier of these dates. The Terrorism exclusion, to which
    this Insurance (Policy) is subject, applies in full force and effect to any
    other losses and any act or events that are not included in said definition
    of "act of terrorism".
  </p>
  <p class="font-small">
    This Endorsement only affects the Terrorism exclusion to which this
    Insurance (Policy) is subject. All other terms, conditions, insured coverage
    and exclusions of this Insurance (Policy) including applicable limits and
    deductibles remain unchanged and apply in full force and effect to the
    coverage provided by this Insurance (Policy).
  </p>
  <p class="font-small">
    Furthermore the Company will not be liable for any amounts for which they
    are not responsible under the terms of TRIA (including subsequent action of
    Congress pursuant to the Act) due to the application of any clause which
    results in a cap on the Company&apos;s liability for payment for terrorism
    losses.
  </p>
</div>
